var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ab-badge",class:[`ab-badge--${_vm.status}`, `ab-badge--${_vm.services}`, `ab-badge--${_vm.size}`, _vm.caps ? 'ab-badge--upper' : 'ab-badge--lower', _vm.innerShadow ? 'ab-badge--inner-shadow' : ''],style:({
    ...(_vm.variant === 'custom' ? {
      background: _vm.customBg || undefined,
      color: _vm.customColor || undefined,
      borderColor: _vm.customBorder || undefined
    } : {}),
    ...(!_vm.bold ? { fontWeight: 500 } : {})
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }